export { default } from "./appTemplate";
